const ServiceApiName = {
  Gstsearch: "GstDetail",
  Cinsearch: "CinDetail",
  Madsearch: "MadDetail",
  CinRefresh: "CinRefreshDetail",
  GstRefresh: "GstRefreshDetail",
  Dinsearch: "DinDetail",
  DinMoblieEmail: "DinMoblieEmail",
  Iecsearch: "IecDetail",
  Msmesearch: "MSMEDetail",
  Pansearch: "PanDetail",
  BusinessPansearch: "BusinessPanDetail",
  PanRefresh: "PanRefreshDetail",
  MsmeRefresh: "MsmeRefreshDetail",
  Mobile360search: "Mobile360Detail",
  MultipleUPI: "MultipleUPI",
  CompnayList: "CompnayList",
  InfoByPhonesearch: "GetFactAppInfoByPhone",
  InfoMoreByPhonesearch: "GetFactAppInfoMoreByPhone",
  InfoByEmailsearch: "GetFactAppInfoByEmail",
  InfoMoreByEmailsearch: "GetFactAppInfoMoreByEmail",
  Pdfsearch: "PdfDetail",
  Darpansearch: "DarpanDetail",
  Mcasearch: "MCAReportDetail",
  GSTPDF: "GSTPDF",
  FTIsearch: "FTIDetail",
};

export default ServiceApiName;
